import { useMemo } from 'react';
import { api } from '@/redux/api';
import { Response } from '@/types/wellbeing-response';
import { useCurrentUnit } from './use-current-unit';

export const useCurrentNotificationResponses = () => {
  const { data: unit } = useCurrentUnit();

  const unitId = unit?.id ?? -1;

  const result = api.useGetResponsesQuery(
    { unitId },
    {
      skip: unitId === -1,
      pollingInterval: 30000,
    },
  );

  function filterResults(results: Response[]) {
    const filteredResults = [];
    for (const item of results) {
      if (item.type == 'responseNotification') {
        filteredResults.push(item);
      }
    }
    return filteredResults;
  }

  const data = useMemo(() => filterResults(result.data ?? []), [result.data]);

  return { ...result, data };
};
